import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const LABEL = { card: "Card", paypal: "PayPal", admin: "Admin grant", unknown: "Unknown" };
const fmt = (d) => (d ? new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : null);

const detail = (info) => {
  if (info.source === "admin") return `Granted${info.granted_by ? ` by ${info.granted_by}` : ""}${info.date ? ` on ${fmt(info.date)}` : ""}`;
  if (info.source === "unknown") return "No payment or grant on record (older account)";
  return `Paid ${fmt(info.date) || ""} · Receipt ${info.receipt_id}`;
};

export const PaidBadge = ({ info, userId }) => {
  if (!info) return null;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span tabIndex={0} className={`mm-chip !cursor-help !text-[11px] !py-0.5 !px-2 whitespace-nowrap ${info.source === "unknown" ? "opacity-70" : ""}`} data-testid={`admin-paid-source-${userId}`}>
            Paid · {LABEL[info.source]}
          </span>
        </TooltipTrigger>
        <TooltipContent data-testid={`admin-paid-detail-${userId}`}>{detail(info)}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
